var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-qa"},[_c('UiHeading',{attrs:{"h":'2',"type":'E2',"text":'乳化クレンジングについてよくある質問'}}),_c('div',{staticClass:"qa-list"},_vm._l((_vm.qaBoxList),function(qaBoxListData){return _c('UiQaQaBox',{key:qaBoxListData.id,staticClass:"item",attrs:{"qestion":qaBoxListData.qestion,"answer":qaBoxListData.answer}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }